import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import { requisicoes as endpoint } from '../constants/URL'

class APIRequisicoes {
  async carregar({ forceUpdate = true, filters = {} } = {}) {
    const params = {}
    if (filters.data_inicio) params.data_inicio = filters.data_inicio
    if (filters.data_fim) params.data_fim = filters.data_fim
    if (filters.context) params.context = filters.context
    if (filters.status) params.status = filters.status

    const queryString = Object.keys(params).length
      ? formatQueryParams(params)
      : ''
    const url = endpoint.list + queryString
    const r = await con.get(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async getStatus({ requestId } = {}) {
    const url = endpoint.detail(requestId)
    const r = await con.get(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async retry({ requestId } = {}) {
    const url = endpoint.retry(requestId)
    const r = await con.post(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async deletar({ requestId } = {}) {
    const url = endpoint.delete(requestId)
    const r = await con.delet(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async download({ requestId, attachmentIndex } = {}) {
    const url = endpoint.download(requestId, attachmentIndex)
    const r = await con.get(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async downloadUploaded({ requestId, attachmentIndex } = {}) {
    const url = endpoint.downloadUploaded(requestId, attachmentIndex)
    const r = await con.get(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }

  async marcarTimeout({ requestId } = {}) {
    const url = endpoint.timeout(requestId)
    const r = await con.put(url)
    return r || { status: 500, message: 'Erro inesperado', value: null }
  }
}

export const apiRequisicoes = new APIRequisicoes()
